// ***************************************
// ComponentContainer
//
// This component contains a number of other components
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 26-9-2015
// ***************************************
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { tbContainer } from "../../engine/tbContainer";
import { PIXI } from "../../engine/tbPIXI";
import { tgfGraphics } from "../tgfGraphics";
import { tgfSettings } from "../tgfSettings";
import { ComponentBase } from "./ComponentBase";
tgfSettings.componentDefaults.container = {
    components: [],
    mask: null
};
var ComponentContainer = /** @class */ (function (_super) {
    __extends(ComponentContainer, _super);
    function ComponentContainer(properties) {
        var _this = _super.call(this) || this;
        _this.name = "Container";
        // Initialize properties
        _this.initialize(tgfSettings.componentDefaults.container);
        // Set user properties
        if (properties !== undefined) {
            _this.setProperties(properties);
        }
        return _this;
    }
    // ***************************************
    // Preparing, showing and activating
    // ***************************************
    // Processing required when preparing the component for use
    ComponentContainer.prototype.doPrepare = function () {
        this.width = this.width || tgfGraphics.areaWidth;
        this.height = this.height || tgfGraphics.areaWidth;
        this.parentBaseContainer = this.baseContainer;
        this._container = new tbContainer(this.width, this.height);
        this.baseContainer.addChild(this._container);
        this.baseContainer = this._container;
        if (this.mask && this.mask instanceof PIXI["Graphics"]) {
            this._container.addChild(this.mask);
            this._container.container.mask = this.mask;
        }
        // Add the child components
        for (var i = 0; i < this.components.length; i += 1) {
            this.addComponent(this.components[i]);
        }
    };
    ComponentContainer.prototype.setScale = function (xScale, yScale) {
        this.xScale = xScale;
        this.yScale = yScale;
        this.baseContainer.setScale(xScale, yScale);
    };
    ComponentContainer.prototype.setAngle = function (angle) {
        this.angle = angle;
        this.baseContainer.setRotation(angle);
    };
    ComponentContainer.prototype.setAlpha = function (alpha) {
        this.alpha = alpha;
        this.baseContainer.setAlpha(this.alpha);
    };
    ComponentContainer.prototype.doFree = function () {
        if (this.mask && this.mask instanceof PIXI["Graphics"]) {
            this._container.remove(this.mask);
        }
        if (this._container) {
            this._container.remove(this.parentBaseContainer);
            this._container.free();
            this._container = null;
            this.baseContainer = null;
        }
    };
    return ComponentContainer;
}(ComponentBase));
export { ComponentContainer };
